module.exports = __webpack_public_path__ + "img/exchange-1.e6712d21.png";